import { styled } from '@mui/material'

export const StyledIcon = styled('span', {
  shouldForwardProp: prop => prop === 'children',
})(({ theme }) => ({
  position: 'relative',
  width: '14px',
  height: '14px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid rgba(123, 123, 142, 0.3)',
  background: theme.palette.common.white,
  borderRadius: '2px',
  boxShadow: 'inset 0px 1px 4px rgba(0, 0, 0, 0.04)',
}))
